import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";

const MANA_POTION_URL = "https://buymeacoffee.com/azerodle";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* Logo + disclaimer */}
        <div className="footer-brand">
          <span className="footer-logo">AZERODLE</span>
          <p className="footer-disclaimer">
            Azerodle is a fan-made project and is not affiliated with, endorsed by,
            or sponsored by Blizzard Entertainment, Inc. World of Warcraft® and all
            related names are trademarks of Blizzard Entertainment, Inc.
          </p>
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Bottom row */}
        <div className="footer-bottom">
          <span className="footer-copy">© {new Date().getFullYear()} Azerodle</span>

          <nav className="footer-links">
            <Link to="/terms">Terms of Service</Link>
            <span className="footer-dot">·</span>
            <Link to="/privacy">Privacy Policy</Link>
          </nav>

          <a
            className="footer-mana-btn"
            href={MANA_POTION_URL}
            target="_blank"
            rel="noreferrer"
          >
            <img src="/mana.png" alt="mana" className="footer-mana-icon" />
            Buy me a Mana Potion
          </a>
        </div>

      </div>
    </footer>
  );
}
